import Cookies from "js-cookie";
import { ACCESS_TOKEN_KEY, COOKIE_OPTIONS, REFRESH_TOKEN_KEY } from "../hooks/useCookies";

export function updateCookies(token: string, refreshToken: string) {
    Cookies.set(ACCESS_TOKEN_KEY, token, {
        ...COOKIE_OPTIONS,
        expires: 7,
    });
    Cookies.set(REFRESH_TOKEN_KEY, refreshToken, {
        ...COOKIE_OPTIONS,
        expires: 30,
    });
}

export function getCookies() {
    const accessToken = Cookies.get(ACCESS_TOKEN_KEY) || null;
    const refreshToken = Cookies.get(REFRESH_TOKEN_KEY) || null;

    return { accessToken, refreshToken };
}
